import { Component, inject } from '@angular/core';
import { ToastService } from '@core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  template: `
    <div class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-[calc(100%-2rem)] max-w-sm">
      @for (t of toast.list(); track t.id) {
        <div
          class="flex items-center justify-between gap-3 rounded-lg px-4 py-3 shadow-lg text-sm font-medium text-white"
          [class.bg-emerald-600]="t.type === 'success'"
          [class.bg-red-600]="t.type === 'error'"
          [class.bg-slate-800]="t.type === 'info'"
        >
          <span>{{ t.message }}</span>
          <button type="button" class="opacity-70 hover:opacity-100 shrink-0" (click)="toast.dismiss(t.id)" aria-label="Cerrar">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12" /></svg>
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  toast = inject(ToastService);
}
